
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/journals",
      function () {
        return require("private-next-pages/journals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/journals"])
      });
    }
  